(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("InstaStepsModalFactory", InstaStepsModalFactory);


    /** @ngInject */
    function InstaStepsModalFactory($uibModal) {

        var factory = {
            update: update
        };

        return factory;

        function update(entity) {
            return $uibModal.open({
                templateUrl: 'app/integrations/instagram-business/steps-modal/insta-steps.modal.html',
                controller: 'InstaModalController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: function() {
                        return entity;
                    }
                }
            }).result;
        }
    }

})();
